import { FunctionComponent } from 'react'
import { Box } from '@black-bear-energy/rucksack'

export const CircledIcon: FunctionComponent<CircledIconProps> = ({
  icon,
  color,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        borderRadius: '50%',
        border: '2.5px solid',
        borderColor: color,
        color: color,
      }}
    >
      {icon}
    </Box>
  )
}

interface CircledIconProps {
  icon: React.ReactNode
  color: string
}
